import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconChartPie16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconChartPie16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.98 8.5a6 6 0 1 1-6.492-6.478V8.5h6.491m0-1H8.488V2.02A6 6 0 0 1 13.98 7.5M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconChartPie16);
